import React from 'react';
import { Link } from 'react-router-dom';
import { FiSmartphone, FiTool, FiTruck, FiShield, FiAward, FiUsers, FiClock, FiThumbsUp, FiShoppingBag, FiHeart, FiTrendingUp } from 'react-icons/fi';

const About = () => {
  const features = [
    {
      icon: FiShoppingBag,
      title: 'សម្លៀកបំពាក់ទាន់សម័យ',
      description: 'បណ្តុំសម្លៀកបំពាក់បុរស និងនារី ម៉ូតថ្មីៗ តាមតម្រូវការទីផ្សារ',
      color: 'black'
    },
    {
      icon: FiShield,
      title: 'ធានាគុណភាព',
      description: 'ធានាគុណភាពសម្លៀកបំពាក់ ១០០% និងសេវាកម្មក្រោយពេលលក់',
      color: 'black'
    },
    {
      icon: FiTruck,
      title: 'ដឹកជញ្ជូនលឿន',
      description: 'ដឹកជញ្ជូនទូទាំងប្រទេស ទទួលបានក្នុងរយៈពេល ២៤-៤៨ម៉ោង',
      color: 'black'
    },
    {
      icon: FiHeart,
      title: 'សេវាកម្មរួសរាយ',
      description: 'បុគ្គលិកជំនាញ ប្រឹក្សាយោបល់ និងបម្រើសេវាកម្មយ៉ាងឆាប់រហ័ស',
      color: 'black'
    }
  ];

  const stats = [
    { number: '3+', label: 'ឆ្នាំបទពិសោធន៍', icon: FiAward },
    { number: '5,000+', label: 'អតិថិជនពេញចិត្ត', icon: FiUsers },
    { number: '24/7', label: 'សេវាកម្ម', icon: FiClock },
    { number: '100%', label: 'គុណភាព', icon: FiThumbsUp }
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      {/* Hero Section */}
      <div className="mb-12 text-center">
        <h1 className="text-2xl md:text-4xl font-bold text-gray-800 mb-4">
          អំពី<span className="text-black">ហាងយើង</span>
        </h1>
        <p className="text-gray-600 max-w-2xl mx-auto text-sm md:text-base">
          NAa Collection ផ្តល់ជូននូវសម្លៀកបំពាក់បុរស និងនារី ទាន់សម័យ 
          គុណភាពខ្ពស់ ជាមួយនឹងការធានាផលិតផល និងសេវាកម្មក្រោយពេលលក់ដ៏ល្អប្រសើរ
        </p>
      </div>

      {/* Features Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 mb-12">
        {features.map((feature, index) => {
          const Icon = feature.icon;
          return (
            <div key={index} className="bg-white border border-gray-200 p-6 hover:border-black hover:shadow-lg transition-all duration-300 group">
              <div className="mb-4">
                <Icon size={32} className="text-black group-hover:scale-110 transition-transform duration-300" />
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">
                {feature.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          );
        })}
      </div>

      {/* Stats Section */}
      <div className="bg-gray-100 border border-gray-200 py-8 mb-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div key={index} className="text-center">
                <Icon size={32} className="text-black mx-auto mb-2" />
                <div className="text-2xl md:text-3xl font-bold text-black mb-1">
                  {stat.number}
                </div>
                <div className="text-sm text-gray-600">{stat.label}</div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Mission & Vision */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
        <div className="border border-gray-200 p-6 hover:border-black transition-all duration-300">
          <h2 className="text-xl font-bold text-gray-800 mb-3">បេសកកម្មរបស់យើង</h2>
          <p className="text-gray-600 text-sm leading-relaxed">
            ផ្តល់ជូនអតិថិជននូវសម្លៀកបំពាក់ដែលមានគុណភាពខ្ពស់ ទាន់សម័យ និងតម្លៃសមរម្យ 
            រួមជាមួយសេវាកម្មក្រោយពេលលក់ដែលគួរទុកចិត្តបាន។
          </p>
        </div>
        <div className="border border-gray-200 p-6 hover:border-black transition-all duration-300">
          <h2 className="text-xl font-bold text-gray-800 mb-3">ចក្ខុវិស័យរបស់យើង</h2>
          <p className="text-gray-600 text-sm leading-relaxed">
            ក្លាយជាហាងលក់សម្លៀកបំពាក់ឈានមុខគេនៅកំពត 
            ដែលត្រូវបានគេស្គាល់ពីគុណភាព និងសេវាកម្មដ៏ល្អឥតខ្ចោះ។
          </p>
        </div>
      </div>

      {/* Why Choose Us */}
      <div className="text-center mb-12">
        <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-6">
          ហេតុអ្វី<span className="text-black">ជ្រើសរើសយើង?</span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="border border-gray-200 p-5 hover:border-black hover:shadow-lg transition-all duration-300">
            <div className="text-black text-3xl mb-3">✓</div>
            <h3 className="font-semibold text-gray-800 mb-2">គុណភាពធានា</h3>
            <p className="text-gray-600 text-sm">សម្លៀកបំពាក់ថ្មី ១០០% គុណភាពខ្ពស់</p>
          </div>
          <div className="border border-gray-200 p-5 hover:border-black hover:shadow-lg transition-all duration-300">
            <div className="text-black text-3xl mb-3">💰</div>
            <h3 className="font-semibold text-gray-800 mb-2">តម្លៃសមរម្យ</h3>
            <p className="text-gray-600 text-sm">តម្លៃប្រកួតប្រជែង សមរម្យសម្រាប់អតិថិជនគ្រប់រូប</p>
          </div>
          <div className="border border-gray-200 p-5 hover:border-black hover:shadow-lg transition-all duration-300">
            <div className="text-black text-3xl mb-3">🏆</div>
            <h3 className="font-semibold text-gray-800 mb-2">សេវាកម្មវិជ្ជាជីវៈ</h3>
            <p className="text-gray-600 text-sm">បុគ្គលិកជំនាញ ប្រឹក្សាយោបល់ល្អ បម្រើសេវាកម្មរហ័ស</p>
          </div>
        </div>
      </div>

      {/* Location Section */}
      <div className="mb-12 bg-gray-50 border border-gray-200 p-6 text-center">
        <h2 className="text-xl font-bold text-gray-800 mb-3">
          📍 ទីតាំងរបស់យើង
        </h2>
        <p className="text-gray-600 text-sm mb-2">
          កំពត (ក្បែររង្វង់មូលទុរេន)
        </p>
        <div className="flex justify-center gap-2 text-2xl mt-3">
          👖 👗 👠 👜 ✨
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-gray-900 border border-gray-800 p-6 text-center">
        <h2 className="text-xl font-bold text-white mb-3">
          ត្រៀមខ្លួនទិញសម្លៀកបំពាក់ថ្មីហើយឬនៅ?
        </h2>
        <p className="text-gray-400 text-sm mb-4">
          ទស្សនាហាងយើងខ្ញុំឥឡូវនេះ ដើម្បីទទួលបានការផ្តល់ជូនពិសេស
        </p>
        <div className="flex gap-3 justify-center flex-wrap">
          <Link
            to="/products"
            className="inline-block bg-black text-white px-6 py-2 text-sm font-medium hover:bg-gray-800 transition-colors"
          >
            ទិញឥឡូវនេះ
          </Link>
          <Link
            to="/contact"
            className="inline-block border border-white text-white px-6 py-2 text-sm font-medium hover:bg-white hover:text-black transition-colors"
          >
            ទំនាក់ទំនង
          </Link>
        </div>
      </div>
    </div>
  );
};

export default About;